import React from 'react';
import dayjs from 'dayjs';
import styles from './styles.module.css';
import AttachmentThumb from '../../../../components/patient-attachments/AttachmentThumb';
import { photoLabel } from '../../modules/evolutionPhotos';

const THUMB_SIZE = 42;
const SIDE_MARKS = Object.freeze({
  before: { mark: 'A', label: 'Antes' },
  after: { mark: 'D', label: 'Depois' },
});

/**
 * Coluna da linha do tempo: um ponto por sessão (data + atendimento), da mais
 * recente para a mais antiga, com a data em destaque e as miniaturas da sessão
 * em fila. A foto em comparação leva a borda na cor principal e a marca do
 * lado ("A" antes, "D" depois); clicar numa miniatura coloca-a no lado ativo
 * do comparador (`onPick`). No celular a coluna vira uma faixa horizontal.
 */
const EvolutionPhotoTimeline = ({ sessions, appointmentId, before, after, onPick }) => {
  const sideOf = (photo) => {
    if (before && photo.id === before.id) return 'before';
    if (after && photo.id === after.id) return 'after';
    return null;
  };

  return (
    <div className={styles.timelineColumn}>
      <div className={styles.timeline} role="list" aria-label="Sessões de fotos">
        {sessions.map((session) => {
          const isCurrent = Boolean(appointmentId && session.appointmentId && String(session.appointmentId) === String(appointmentId));
          return (
            <div
              key={session.key}
              role="listitem"
              className={`${styles.timelineSession} ${isCurrent ? styles.timelineSessionCurrent : ''}`}
            >
              <div className={styles.timelineHead}>
                <span className={styles.timelineDate}>
                  {session.date ? dayjs(session.date).format('DD/MM/YYYY') : 'Sem data'}
                </span>
                {isCurrent && <span className={styles.sessionTag}>Este atendimento</span>}
              </div>

              <div className={styles.timelineThumbs}>
                {session.photos.map((photo) => {
                  const side = sideOf(photo);
                  const label = photoLabel(photo);
                  return (
                    <button
                      key={photo.id}
                      type="button"
                      className={`${styles.timelineThumb} ${side ? styles.timelineThumbSelected : ''}`}
                      title={label}
                      aria-label={side ? `${label}, em comparação como ${SIDE_MARKS[side].label}` : `Comparar ${label}`}
                      aria-pressed={Boolean(side)}
                      onClick={() => onPick(photo)}
                    >
                      <AttachmentThumb attachment={photo} size={THUMB_SIZE} />
                      {side && <span className={styles.timelineMark} aria-hidden="true">{SIDE_MARKS[side].mark}</span>}
                    </button>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default EvolutionPhotoTimeline;
